import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import { addEventAction } from 'redux/slices/eventSlice';
import { getCmsFingerPrint } from 'redux/slices/userSlice';

function useICallGenerator() {
    const user = useSelector(getUser);
    const { t } = useTranslation();
    const cmsFingerPrint = useSelector(getCmsFingerPrint);
    const dispatch = useDispatch();

    function handleInstantCall(gest) {
        dispatch(
            addEventAction(
                {
                    name: t('event.eventSessionCreate.psEvent'),
                    adminUserId: user?.userId,
                    releaseDate: new Date(),
                    description: '',
                    recurrency: '',
                    actors: [
                        {
                            userId: user?.userId,
                            email: user?.email,
                            isAdmin: true,
                            role: 'host',
                            avatar: user?.avatar,
                        },
                        {
                            role: 'guest',
                            email: gest?.email,
                        },
                    ],
                    discountCodes: [],
                    stickers: [],
                    assets: [],
                    products: [],
                    inviteeName: null,
                    inviteeEmail: gest?.email,
                    sessionRequestId: null,
                    calendlyEventTypeUri: null,
                    calendlyEventUri: null,
                    type: 'one_to_one',
                    instant: true,
                    isTemplate: true,
                    isPublic: false,
                    hostProvider: 'web',
                    streamConnectors: [],
                    mainImage: null,
                    socialConnectors: [],
                    socialInfo: null,
                    record: false,
                    cmsFingerPrint,
                },
                () => {},
                (taskResult) => console.debug(taskResult),
            ),
        );
    }

    return { handleInstantCall };
}

export default useICallGenerator;
